define("shared/models/ig-post", ["exports", "@ember/object", "@ember/utils", "ember-api-actions", "moment", "tracked-built-ins", "later/models/ig-preview-post", "later/utils/formatters/caption-from-regram", "later/utils/secure-url"], function (_exports, _object, _utils, _emberApiActions, _moment, _trackedBuiltIns, _igPreviewPost, _captionFromRegram, _secureUrl) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.DynamoIgPost = void 0;
  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _class2;
  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"@ember/utils",0,"ember-api-actions",0,"ember-classic-decorator",0,"moment",0,"tracked-built-ins",0,"later/models/ig-preview-post",0,"later/utils/formatters/caption-from-regram",0,"later/utils/secure-url"eaimeta@70e063a35619d71f
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  const LOW_RES_THRESHOLD = 500;
  let IgPost = _exports.default = (_dec = (0, _object.computed)('createdMoment'), _dec2 = (0, _object.computed)('createdMoment'), _dec3 = (0, _object.computed)('caption', 'username', 'link', 'instagramProfiles'), _dec4 = (0, _object.computed)('caption'), _dec5 = (0, _object.computed)('createdTime'), _dec6 = (0, _object.computed)('createdTime'), _dec7 = (0, _object.computed)('createdMoment'), _dec8 = (0, _object.computed)('commentCount', 'likeCount'), _dec9 = (0, _object.computed)('linkinbioPost'), _dec10 = (0, _object.computed)('locationId'), _dec11 = (0, _object.computed)('pagingInfo'), _dec12 = (0, _object.computed)('account'), _dec13 = (0, _object.computed)('type'), _dec14 = (0, _object.computed)('type'), _dec15 = (0, _object.computed)('type'), _dec16 = (0, _object.computed)('mediaProductType', 'permalink'), _dec17 = (0, _object.computed)('mediaProductType'), _dec18 = (0, _object.computed)('width', 'height'), _dec19 = (0, _object.computed)('username', 'instagramProfiles'), _dec20 = (0, _object.computed)('createdMoment'), _dec21 = (0, _object.computed)('createdMoment'), _dec22 = (0, _object.computed)('lowBandwidthVideoUrl'), _dec23 = (0, _object.computed)('lowResUrl'), _dec24 = (0, _object.computed)('lowResVideoUrl'), _dec25 = (0, _object.computed)('standardResUrl'), _dec26 = (0, _object.computed)('standardResVideoUrl'), _dec27 = (0, _object.computed)('thumbUrl'), _dec28 = (0, _object.computed)('createdTime'), (_class2 = class IgPost extends _object.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "account", void 0);
      _defineProperty(this, "caption", '');
      _defineProperty(this, "carouselMediaItems", new _trackedBuiltIns.TrackedArray());
      _defineProperty(this, "commentCount", 0);
      _defineProperty(this, "createdTime", void 0);
      _defineProperty(this, "followersOnPost", void 0);
      _defineProperty(this, "height", void 0);
      _defineProperty(this, "id", void 0);
      _defineProperty(this, "igId", void 0);
      _defineProperty(this, "isDeleted", false);
      _defineProperty(this, "isIGPost", true);
      _defineProperty(this, "likeCount", 0);
      _defineProperty(this, "link", void 0);
      // Note: transient, used in our Lib Management page -iMac
      _defineProperty(this, "linkinbioPost", void 0);
      _defineProperty(this, "locationId", void 0);
      _defineProperty(this, "locationName", void 0);
      _defineProperty(this, "lowBandwidthVideoUrl", void 0);
      _defineProperty(this, "lowResUrl", '');
      _defineProperty(this, "lowResVideoUrl", '');
      _defineProperty(this, "mediaProductType", void 0);
      _defineProperty(this, "pagingInfo", void 0);
      _defineProperty(this, "permalink", void 0);
      _defineProperty(this, "socialProfile", void 0);
      _defineProperty(this, "standardResUrl", void 0);
      _defineProperty(this, "standardResVideoUrl", void 0);
      _defineProperty(this, "tags", []);
      _defineProperty(this, "thumbUrl", '');
      _defineProperty(this, "timeCollected", void 0);
      _defineProperty(this, "type", void 0);
      _defineProperty(this, "userHasLiked", false);
      _defineProperty(this, "userId", void 0);
      _defineProperty(this, "username", void 0);
      _defineProperty(this, "userProfileUrl", void 0);
      _defineProperty(this, "userTags", new _trackedBuiltIns.TrackedArray());
      _defineProperty(this, "width", void 0);
      _defineProperty(this, "verify", (0, _emberApiActions.memberAction)({
        path: 'verify',
        type: 'post'
      }));
    }
    get analyticsChartFormattedCreatedTime() {
      return this.formatCreatedTime('MMM D/YY, h:mma');
    }
    get analyticsDetailFormattedCreatedTime() {
      return this.formatCreatedTime('MMM. D, YYYY, h:mma');
    }
    get captionText() {
      const {
        caption,
        link
      } = this;
      let {
        username
      } = this;
      if (this.isOwnPost) {
        username = undefined;
      }
      return (0, _captionFromRegram.default)({
        caption,
        username,
        link
      });
    }
    get captionTruncated() {
      const {
        caption
      } = this;
      if (caption && caption.length > 100) {
        return caption.substring(0, 100) + '...';
      }
      return caption;
    }
    get createdMoment() {
      if (!this.createdTime) {
        return undefined;
      }
      if (typeof this.createdTime === 'string') {
        return (0, _moment.default)(this.displayTime * 1000);
      }
      return (0, _moment.default)(this.createdTime * 1000);
    }
    get displayTime() {
      if (typeof this.createdTime === 'string') {
        return parseInt(this.createdTime);
      }
      return this.createdTime || 0;
    }
    get formattedTimeSinceCreated() {
      return (0, _moment.default)(this.formatCreatedTime('ddd, MMM D YYYY LT')).fromNow();
    }
    get hasCommentsAndLikes() {
      return Object.prototype.hasOwnProperty.call(this, 'commentCount') && Object.prototype.hasOwnProperty.call(this, 'likeCount');
    }
    get hasLinkinbioPost() {
      return !(0, _utils.isEmpty)(this.linkinbioPost);
    }
    get hasLocation() {
      return !(0, _utils.isNone)(this.locationId);
    }
    get hasMoreComments() {
      return !(0, _utils.isEmpty)(this.pagingInfo);
    }
    get instagramProfiles() {
      return this.account?.get('instagramProfiles');
    }
    get isCarouselPost() {
      return this.type?.toLowerCase() === 'carousel_album';
    }
    get isImage() {
      return this.type?.toLowerCase() === 'image';
    }
    get isVideo() {
      return this.type?.toLowerCase() === 'video';
    }
    get isReels() {
      return Boolean(this.mediaProductType === 'REELS' || this.permalink?.includes('/reel/'));
    }
    get isIGTV() {
      return this.mediaProductType === 'IGTV';
    }
    get isLowRes() {
      if (!this.width || !this.height) {
        return false;
      }
      return this.width < LOW_RES_THRESHOLD && this.height < LOW_RES_THRESHOLD;
    }
    get isOwnPost() {
      if (this.instagramProfiles) {
        return this.instagramProfiles.any(profile => (0, _utils.isEqual)(this.username, profile.nickname));
      }
      return false;
    }
    get manualMatchingFormattedCreatedDate() {
      return this.formatCreatedTime('MMM D YYYY');
    }
    get manualMatchingFormattedCreatedTime() {
      return this.formatCreatedTime('h:mm A');
    }
    get secureLowBandwitdhVideoUrl() {
      return (0, _secureUrl.secureUrl)(this.lowBandwidthVideoUrl);
    }
    get secureLowResUrl() {
      return (0, _secureUrl.secureUrl)(this.lowResUrl);
    }
    get secureLowResVideoUrl() {
      return (0, _secureUrl.secureUrl)(this.lowResVideoUrl);
    }
    get secureStandardResUrl() {
      return (0, _secureUrl.secureUrl)(this.standardResUrl);
    }
    get secureStandardResVideoUrl() {
      return (0, _secureUrl.secureUrl)(this.standardResVideoUrl);
    }
    get secureThumbUrl() {
      return (0, _secureUrl.secureUrl)(this.thumbUrl);
    }
    get yearMonthFormattedCreatedTime() {
      if (!this.createdTime) {
        return undefined;
      }
      return _moment.default.unix(this.displayTime).format('YYYY-MM');
    }
    formatCreatedTime(format) {
      return this.createdMoment?.format(format);
    }
    igPreviewPost() {
      const createParams = {
        id: 'ig-post-' + this.id,
        socialProfile: this.get('socialProfile'),
        igPost: this,
        scheduledTime: this.displayTime
      };
      return _igPreviewPost.default.create(createParams);
    }
  }, (_applyDecoratedDescriptor(_class2.prototype, "analyticsChartFormattedCreatedTime", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "analyticsChartFormattedCreatedTime"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "analyticsDetailFormattedCreatedTime", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "analyticsDetailFormattedCreatedTime"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "captionText", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "captionText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "captionTruncated", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "captionTruncated"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "createdMoment", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "createdMoment"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "displayTime", [_dec6], Object.getOwnPropertyDescriptor(_class2.prototype, "displayTime"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "formattedTimeSinceCreated", [_dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "formattedTimeSinceCreated"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasCommentsAndLikes", [_dec8], Object.getOwnPropertyDescriptor(_class2.prototype, "hasCommentsAndLikes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasLinkinbioPost", [_dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "hasLinkinbioPost"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasLocation", [_dec10], Object.getOwnPropertyDescriptor(_class2.prototype, "hasLocation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasMoreComments", [_dec11], Object.getOwnPropertyDescriptor(_class2.prototype, "hasMoreComments"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "instagramProfiles", [_dec12], Object.getOwnPropertyDescriptor(_class2.prototype, "instagramProfiles"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isCarouselPost", [_dec13], Object.getOwnPropertyDescriptor(_class2.prototype, "isCarouselPost"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isImage", [_dec14], Object.getOwnPropertyDescriptor(_class2.prototype, "isImage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isVideo", [_dec15], Object.getOwnPropertyDescriptor(_class2.prototype, "isVideo"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isReels", [_dec16], Object.getOwnPropertyDescriptor(_class2.prototype, "isReels"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isIGTV", [_dec17], Object.getOwnPropertyDescriptor(_class2.prototype, "isIGTV"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isLowRes", [_dec18], Object.getOwnPropertyDescriptor(_class2.prototype, "isLowRes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isOwnPost", [_dec19], Object.getOwnPropertyDescriptor(_class2.prototype, "isOwnPost"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "manualMatchingFormattedCreatedDate", [_dec20], Object.getOwnPropertyDescriptor(_class2.prototype, "manualMatchingFormattedCreatedDate"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "manualMatchingFormattedCreatedTime", [_dec21], Object.getOwnPropertyDescriptor(_class2.prototype, "manualMatchingFormattedCreatedTime"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "secureLowBandwitdhVideoUrl", [_dec22], Object.getOwnPropertyDescriptor(_class2.prototype, "secureLowBandwitdhVideoUrl"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "secureLowResUrl", [_dec23], Object.getOwnPropertyDescriptor(_class2.prototype, "secureLowResUrl"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "secureLowResVideoUrl", [_dec24], Object.getOwnPropertyDescriptor(_class2.prototype, "secureLowResVideoUrl"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "secureStandardResUrl", [_dec25], Object.getOwnPropertyDescriptor(_class2.prototype, "secureStandardResUrl"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "secureStandardResVideoUrl", [_dec26], Object.getOwnPropertyDescriptor(_class2.prototype, "secureStandardResVideoUrl"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "secureThumbUrl", [_dec27], Object.getOwnPropertyDescriptor(_class2.prototype, "secureThumbUrl"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "yearMonthFormattedCreatedTime", [_dec28], Object.getOwnPropertyDescriptor(_class2.prototype, "yearMonthFormattedCreatedTime"), _class2.prototype)), _class2));
  class DynamoIgPost extends IgPost {
    constructor() {
      super(...arguments);
      _defineProperty(this, "followersOnPost", 0);
      _defineProperty(this, "imageUrl", void 0);
      _defineProperty(this, "engagement", void 0);
      _defineProperty(this, "engagementRaw", void 0);
      _defineProperty(this, "impressions", void 0);
      _defineProperty(this, "views", void 0);
      _defineProperty(this, "reach", void 0);
      _defineProperty(this, "savedCount", void 0);
      _defineProperty(this, "videoViews", void 0);
      _defineProperty(this, "shareCount", void 0);
      _defineProperty(this, "reposts", void 0);
      _defineProperty(this, "followersCount", 0);
      _defineProperty(this, "instagramLink", void 0);
      _defineProperty(this, "linkinbioClicks", void 0);
      _defineProperty(this, "linkinbioPostId", void 0);
      _defineProperty(this, "linkinbioMediaId", void 0);
      _defineProperty(this, "scheduledPost", void 0);
    }
  }
  _exports.DynamoIgPost = DynamoIgPost;
});